import '@actr/style/src/themes/aviakassa/light.css';

import { prepareRoutesPaths } from '@actr/utilities/src/navigation/prepare-route-paths';
import NotFound from '@actr/widgets/src/components/_misc/not-found';
import { SiteLoader } from '@actr/widgets/src/components/_misc/site-loader';
import AuthorizationPageWrapper from '@actr/widgets/src/hoc/authorization-page-wrapper';
import { AkV2Routes } from '@actr/widgets/src/navigation/routes/ak-v2';
import type { FC } from 'react';
import React, { lazy, memo, Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';

const HomePage = lazy(() => import('Pages/ak-redesign/home'));
const AviaResultPage = lazy(() => import('Pages/ak-redesign/avia/results/results'));
const AviaBookingPage = lazy(() => import('Pages/ak-redesign/avia/booking/booking'));
const AviaCheckoutPage = lazy(() => import('Pages/ak-redesign/avia/checkout/checkout'));
const AviaPostBookingPage = lazy(() => import('Pages/ak-redesign/avia/post-booking/post-booking'));
const AviaPostSalesPage = lazy(() => import('Pages/ak-redesign/avia/post-sales/post-sales'));
const AviaCheckoutPostSalesPage = lazy(() => import('Pages/ak-redesign/avia/checkout-post-sales/checkout-post-sales'));
const AviaMarketingSubscribesPage = lazy(() => import('Pages/ak-redesign/avia/marketing-subscribe/marketing-subscribe'));
const AviaMarketingUnsubscribesPage = lazy(() => import('Pages/ak-redesign/avia/marketing-unsubscribe/marketing-unsubscribe'));
const HotelSearchPage = lazy(() => import('Pages/ak-redesign/hotel/search'));
const HotelResultsPage = lazy(() => import('Pages/ak-redesign/hotel/results'));
const HotelSelectPage = lazy(() => import('Pages/ak-redesign/hotel/select'));
const HotelBookingPage = lazy(() => import('Pages/ak-redesign/hotel/booking'));
const HotelCheckoutPage = lazy(() => import('Pages/ak-redesign/hotel/checkout'));
const RailSearchPage = lazy(() => import('Pages/ak-redesign/rail/search'));
const AppPage = lazy(() => import('Pages/ak-redesign/common/app-page'));

const AkRedesignRouter: FC = () => (
  <AuthorizationPageWrapper>
    <Suspense fallback={<SiteLoader />}>
      <Switch>
        {/* HOME */}
        <Route exact={true} path={prepareRoutesPaths(AkV2Routes.HOME)} component={HomePage} />
        <Route exact={true} path={prepareRoutesPaths(AkV2Routes.AVIA)} component={HomePage} />

        {/* AVIA */}
        <Route path={prepareRoutesPaths(AkV2Routes.AVIA_SEARCH)} component={AviaResultPage} />
        <Route path={prepareRoutesPaths(AkV2Routes.AVIA_RESULTS)} component={AviaResultPage} />
        <Route path={prepareRoutesPaths(AkV2Routes.AVIA_BOOKING)} component={AviaBookingPage} />
        <Route path={prepareRoutesPaths(AkV2Routes.AVIA_POST_BOOKING)} component={AviaPostBookingPage} />
        <Route path={prepareRoutesPaths(AkV2Routes.AVIA_POST_SALES)} component={AviaPostSalesPage} />
        <Route path={prepareRoutesPaths(AkV2Routes.AVIA_CHECKOUT_POST_SALES)} component={AviaCheckoutPostSalesPage} />
        <Route path={prepareRoutesPaths(AkV2Routes.AVIA_MARKETING_SUBSCRIBE)} component={AviaMarketingSubscribesPage} />
        <Route path={prepareRoutesPaths(AkV2Routes.AVIA_MARKETING_UNSUBSCRIBE)} component={AviaMarketingUnsubscribesPage} />
        <Route exact={true} path={prepareRoutesPaths(AkV2Routes.AVIA_CHECKOUT)} component={AviaCheckoutPage} />
        <Route exact={true} path={prepareRoutesPaths(AkV2Routes.AVIA_CHECKOUT_OLD)} component={AviaCheckoutPage} />

        {/* HOTEL */}
        <Route exact={true} path={prepareRoutesPaths(AkV2Routes.HOTEL)} component={HotelSearchPage} />
        <Route path={prepareRoutesPaths(AkV2Routes.HOTEL_RESULTS)} component={HotelResultsPage} />
        <Route path={prepareRoutesPaths(AkV2Routes.HOTEL_SELECT)} component={HotelSelectPage} />
        <Route path={prepareRoutesPaths(AkV2Routes.HOTEL_BOOKING)} component={HotelBookingPage} />
        <Route exact={true} path={prepareRoutesPaths(AkV2Routes.HOTEL_CHECKOUT)} component={HotelCheckoutPage} />

        {/* RAILWAY */}
        <Route exact={true} path={prepareRoutesPaths(AkV2Routes.RAILWAY)} component={RailSearchPage} />

        {/* COMMON */}
        <Route exact={true} path={prepareRoutesPaths(AkV2Routes.APP)} component={AppPage} />

        {/*
         SEO
        <Route path={Routes.CITYTOCITY} component={CityToCityPage} />

         Home travel
        <Route path={Routes.HOME_TRAVEL} component={HomeTravelPage} /> */}

        {/* Not Found */}
        <Route>
          <NotFound />
        </Route>
      </Switch>
    </Suspense>
  </AuthorizationPageWrapper>
);

export default memo(AkRedesignRouter);
